import { GetServerSideProps } from 'next/types';

import Layout from '@/components/layout/LayoutWrapper';
import SimplifiedSignup from '@/components/SimplifiedSignup';
import BlogDiscountOfferConfig from '@/components/SimplifiedSignup/configs/Blog-Discount-Offer/Flow';
import { SimplifiedSignupContextProvider } from '@/components/SimplifiedSignup/Context';
import { shapeConfigForParams } from '@/components/SimplifiedSignup/Context/utils';
import { InitRequest } from '@/hooks/store/useInitState';
import type { InitialServerState } from '@/store';
import { resolveCheckoutSessionsEnabled } from '@/utils/experiments/resolveCheckoutSessionsEnabled';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

type Props = {
	initialState: InitialServerState | null;
	isCheckoutSessionsEnabled: boolean;
};

const BlogDiscountOffer = ({ isCheckoutSessionsEnabled }: Props) => {
	return (
		<Layout pageName="blog-discount-offer">
			<SimplifiedSignupContextProvider
				flowConfig={BlogDiscountOfferConfig}
				isCheckoutSessionsEnabled={isCheckoutSessionsEnabled}
			>
				<SimplifiedSignup />
			</SimplifiedSignupContextProvider>
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps<Props> = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.PRICES, InitRequest.USER],
		shapeConfigForParams(BlogDiscountOfferConfig),
	);

	// Resolved server-side so the payment screen's first render already
	// knows the buyer's `www-checkout-sessions` bucket (see the enrollment
	// latch in PaymentElementsFormRefresh).
	const isCheckoutSessionsEnabled = await resolveCheckoutSessionsEnabled(initialState);

	return {
		props: {
			initialState,
			isCheckoutSessionsEnabled,
		},
	};
};

export default BlogDiscountOffer;
